<template lang="pug">
  div
    //- Create(:createDialog="createDialog" @close="close" @created="created")
    Edit(:editDialog="editDialog" :reconcile="service.reconcile" @close="close" @updated="updated")
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('labels.reconcileService') }}
        v-spacer
        v-btn(small color='pink' dark @click="editDialog = true" icon)
          v-icon(small) edit
      v-card-text
        v-layout(column)
          v-layout(row wrap)
            v-flex {{ $t('labels.assignedUser') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right(v-if="service.reconcile.assignedToUser") {{ service.reconcile.assignedToUser.fullName }}
            v-flex.font-weight-regular.text-xs-right(v-else) Not Assigned
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.plan') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right(v-if="service.reconcile.Product.productDetail") {{ service.reconcile.Product.productDetail }}
            v-flex.font-weight-regular.text-xs-right(v-else) Not Set
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.fee') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.reconcile.softwareFee | currency }}
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.teamviewerid') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.reconcile.teamViewerID }}
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.accessCode') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.reconcile.accessCode }}
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.userName') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.reconcile.userName }}
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.password') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right {{ service.reconcile.password }}
          v-divider
          v-layout(row wrap)
            v-flex {{ $t('labels.folderLink') }}
            v-spacer
            v-flex.font-weight-regular.text-xs-right 
              a(@click="openLink") Open Link

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import reconcileService from '../service.js'
import locationService from '../../../Location/service.js'
const Edit = () => import('./Edit')

export default {
  data() {
    return {
      createDialog: false,
      editDialog: false,
      isReconcile: false,
    }
  },
  computed: {
    ...mapGetters('location', ['location', 'service']),
  },
  components: {
    Edit
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    openLink() {
      window.open(`${this.service.reconcile.folderLink}`,"_blank");
    },
    created() {
      this.createDialog = false
    },
    updated() {
      this.editDialog = false
    },
    close() {
      this.createDialog = false
      this.editDialog = false
    },
    // getByStoreID() {
    //   reconcileService.getByStoreID(this.location.storeID)
    //   .then(result => {
    //     this.reconcile = result.data
    //   })
    // },
    updateStore(data) {
      return locationService.updateStore(this.location.storeID, data)
      .then(result => {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'success',
          title: 'Update Successfully'
        })
        this.setLocation(this.location.storeID)
      })
    },
    // async updateReconcile(val) {
    //   if (val.value) {
    //     if(this.reconcile) {
    //       this.isReconcile = val.value
    //       this.location.reconcile = val.value
    //       let data = {
    //         reconcile: val.value
    //       }
    //       this.updateStore(data)
    //     } else {
    //       this.createDialog = true
    //     }
    //   }else {
    //     const {value: text} = await this.$swal.fire({
    //     title: 'Reason',
    //     input: 'textarea',
    //     inputPlaceholder: 'Type your message here...',
    //     showCancelButton: true
    //     })
    //     if (text) {
    //       let data = {
    //         reconcileReason: text,
    //         reconcile: val.value
    //       }
    //       this.updateStore(data)
    //       this.reconcile = null
    //       this.showEdit = false
    //     } else {
    //       this.isReconcile = !this.isReconcile
    //     }
    //   }
    // },
  }
}
</script>

<style scoped>
</style>